import moment from 'moment';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { combineEpics } from 'redux-observable';
import { versaItRoot } from 'config.json';

const namespace = 'jobpro/scheduler/modals/printWorkOrderModal';
const CHANGE_WORK_ORDER_TEMPLATE = `${namespace}/CHANGE_WORK_ORDER_TEMPLATE`;
const CLOSE = `${namespace}/CLOSE`;
const CONFIRM = `${namespace}/CONFIRM`;
const CONFIRM_COMPLETE = `${namespace}/CONFIRM_COMPLETE`;
const OPEN = `${namespace}/OPEN`;
const OPEN_CONFIRM = `${namespace}/OPEN_CONFIRM`;

// Default state
const DEFAULT_STATE = {
  calendarEvents: [],
  show: false,
  workOrderTemplateId: null
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case CHANGE_WORK_ORDER_TEMPLATE:
      return {
        ...state,
        workOrderTemplateId: payload
      };
    case CLOSE:
    case CONFIRM_COMPLETE:
      return DEFAULT_STATE;
    case OPEN_CONFIRM:
      return {
        ...state,
        calendarEvents: payload.calendarEvents,
        date: payload.date,
        show: true
      };
    default:
      return state;
  }
}

// Action creators
export const changeWorkOrderTemplate = workOrderTemplateId => ({
  type: CHANGE_WORK_ORDER_TEMPLATE,
  payload: workOrderTemplateId
});

export const close = () => ({
  type: CLOSE
});

export const confirm = options => ({
  type: CONFIRM,
  payload: options
});

const confirmComplete = () => ({
  type: CONFIRM_COMPLETE
});

export const open = (payload) => ({
  type: OPEN,
  payload: {
    calendarEvents: Array.isArray(payload.eventId) ? payload.eventId : [payload.eventId],
    date: payload.date
  }
});

const openConfirm = (payload) => ({
  type: OPEN_CONFIRM,
  payload: {
    calendarEvents: Array.isArray(payload.eventId || payload.calendarEvents) ? (payload.eventId || payload.calendarEvents) : [payload.eventId || payload.calendarEvents],
    date: payload.date
  }
});

// Epics
const confirmEpic = (action$, state$) => action$.pipe(
  ofType(CONFIRM),
  map(({ payload }) => {
    const state = state$.value;
    //const { date } = state.calendar;
    if (payload) {
      return {
        ...payload
      };
    } else {
      const { calendarEvents, workOrderTemplateId, date } = state.modals.printWorkOrderModal;
      const { workOrderTemplates } = state.workOrders;
      return {
        calendarEvents,
        date,
        workOrderTemplateId: workOrderTemplateId || workOrderTemplates.map(t => t.uniqueId)[0]
      };
    }
  }),
  map(({ date, calendarEvents, workOrderTemplateId }) => {
    const eventsQuery = calendarEvents.filter(j => String(j).indexOf("JOB") === -1).map(j => `eventId=${j}`).join('&');
    window.open(`${versaItRoot}/JP_MVC/scheduler/WorkOrder.pdf?${eventsQuery}&workOrderTemplateId=${workOrderTemplateId || ''}&scheduledDate=${moment(date).format('YYYY-MM-DD')}`);
  }),
  map(confirmComplete),
);

const openEpic = (action$, state$) => action$.pipe(
  ofType(OPEN),
  map(({ payload }) => {
    const templates = state$.value.workOrders.workOrderTemplates;
    if (templates.length > 1) {
      return openConfirm(payload);
    } else {
      return confirm({
        calendarEvents: payload.calendarEvents,
        date: payload.date,
        workOrderTemplateId: templates.map(t => t.id)[0]
      });
    }
  }),
);

export const epic = combineEpics(
  confirmEpic,
  openEpic
);
